import React, { useState, useEffect } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import Navbar from './Navbar';
import Sidebar from './Sidebar';
import CreditRouteGuard from '../CreditRouteGuard';
import { useAuth } from '../../contexts/AuthContext';
import { TourProvider } from '../../tour/TourContext';
import DemoBanner from '../../tour/DemoBanner';
import DemoSessionBanner from '../DemoSessionBanner';

const MainLayout: React.FC = () => {
  const { user } = useAuth();
  const [userRole, setUserRole] = useState<string>('');
  const location = useLocation();
  // Match sidebar geometry (m-4 + h-[95vh]): no top navbar, same 16px inset
  const isMessages = location.pathname === '/messages';
  const impersonating = Boolean(user?.impersonating);

  useEffect(() => {
    try {
      const userStr = localStorage.getItem('user');
      if (userStr) {
        const parsed = JSON.parse(userStr);
        setUserRole(parsed.role || '');
      }
    } catch {}
  }, [user]);

  // SUPER_ADMIN (not impersonating) belongs in /admin
  if ((user?.role === 'SUPER_ADMIN' || userRole === 'SUPER_ADMIN') && !impersonating && !user?.impersonating) {
    return <Navigate to="/admin" replace />;
  }

  return (
    <CreditRouteGuard userRole={userRole}>
      <TourProvider>
        <div className={`min-h-screen bg-[#F7F8FA] flex ${impersonating ? 'pt-12' : ''}`}>
          {/* Sidebar fixed on the left */}
          <div className={`fixed left-0 h-full z-30 ${impersonating ? 'top-12' : 'top-0'}`}>
            <Sidebar />
          </div>
          {/* Main content area with left margin */}
          <div className="flex-1 ml-[272px]">
            {!isMessages && <Navbar />}
            <main className={isMessages ? 'p-4' : 'p-6'}>
              <DemoSessionBanner />
              <DemoBanner />
              <Outlet />
            </main>
          </div>
        </div>
      </TourProvider>
    </CreditRouteGuard>
  );
};

export default MainLayout; 